export default "__VITE_ASSET__LsPHyaxf__"